import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SmartService {

	constructor(
		private apiService: ApiService,
	) { }

	getRefundRequest(query) {
		const refundURL = environment.smartServiceURL + '/api/smart/v1/refund/request/list?' + query;
		return this.apiService.get(refundURL);
	}
	paymentRefundReview(body) {
		const reviewURL = environment.smartServiceURL + '/api/smart/v1/refund/financespoc/action';
		return this.apiService.post(reviewURL, body);
	}
	submitRefundStatus(body) {
		const refundRequest = environment.smartServiceURL + '/api/smart/v1/refund/request';
		return this.apiService.post(refundRequest, body);
	}
	applyRefund(payLoad, appealRefundRequired?) {
		if (appealRefundRequired && appealRefundRequired === true) {
			const refundRequest = environment.smartServiceURL + '/api/smart/v1/appeal/tc/applyrefund/appeal';
			return this.apiService.post(refundRequest, payLoad);
		} else {
			const refundRequest = environment.smartServiceURL + '/api/smart/v1/refund/request';
			return this.apiService.post(refundRequest, payLoad);
		}

	}

	applyRefundMigratredTC(payload) {
		const refundRequest = environment.smartServiceURL + '/api/smart/v1/refund/tc';
		return this.apiService.post(refundRequest, payload);
	}
	getMigratedRefundRequest(query) {
		const migratedRefundUrl = environment.smartServiceURL + '/api/smart/v1/refund/fspoc?' + query;
		return this.apiService.get(migratedRefundUrl);
	}
	getTcDetailsByIdForAms(tcId) {
		const URL = `${environment.userServiceUrl
			}/api/user/v1/trainingcentre/${tcId}`;
		return this.apiService.get(URL);
	}

	updateTrainingCentreStatus(payload) {
		const tcStatusChangeurl = environment.pmkvycmServiceUrl + '/api/v2/batchservice/ams/updateTcStatus';
		return this.apiService.put(tcStatusChangeurl, payload);
	}

	getTrainingCentreGeneralStatus() {
		const getStatusOfTc = environment.pmkvycmServiceUrl + '/api/v2/batchservice/ams/getTcStatusList';
		return this.apiService.get(getStatusOfTc);
	}

	deactivateTc(payload) {
		const deactivateTcUrl = environment.pmkvycmServiceUrl + '/api/v2/batchservice/ams/deactivateTc';
		return this.apiService.put(deactivateTcUrl, payload);
	}

	deactivateTp(payload) {
		const deactivateTpUrl = environment.pmkvycmServiceUrl + '/api/v2/batchservice/ams/deactivateTp';
		return this.apiService.put(deactivateTpUrl, payload);
	}
	sscCompletedForAllJobroles(tcId) {
		const migratedRefundUrl = environment.smartServiceURL + '/api/smart/v1/tc/' + tcId + '/sscvalidation';
		return this.apiService.get(migratedRefundUrl);
	}
	getPaymenRefundArrovalComents(paymentId) {
		const url = environment.smartServiceURL + `/api/smart/v1/refund/conversation/tp/fianace?paymentID=${paymentId}`;
		return this.apiService.get(url);
	}
	applyRefundDuplicateEntries(payload) {
		const url = environment.smartServiceURL + '/api/smart/v1/refund/markPayment/refund';
		return this.apiService.post(url, payload);
	}
	getPaymentOTP(payLoad) {
		const URL = environment.userServiceUrl + `/api/user/v1/refund/generateOTP`;
		return this.apiService.post(URL, payLoad);
	}
	verifiedOTP(payLoad) {
		const URL = environment.userServiceUrl + `/api/user/v1/refund/validateOTP`;
		return this.apiService.post(URL, payLoad);
	}
	submitRefundGDC(payload) {
		const url = environment.smartServiceURL + '/api/smart/v1/refund/tp/action';
		return this.apiService.patch(url, payload);
	}
	knowledgeBankDate() {
		const url = environment.sqaServiceUrl + '/api/sqa/qp/specification/timestamp';
		return this.apiService.get(url);
	}
	getTrainerData() {
		const url = environment.sqaServiceUrl + '/api/sqa/trainerspec/report';
		return this.apiService.getBlob(url, 'application/vnd.ms-excel');
	}
	getLabData() {
		const url = environment.sqaServiceUrl + '/api/sqa/labspec/report'
		return this.apiService.getBlob(url, 'application/vnd.ms-excel');
	}
	getEquipmentData() {
		const url = environment.sqaServiceUrl + '/api/sqa/equipment/report'
		return this.apiService.getBlob(url, 'application/vnd.ms-excel');
	}
	getNoticesData() {
		const url = `${environment.smartServiceURL}/api/smart/v1/getnotification`;
		return this.apiService.get(url);
	}
	submitReRefund(payload) {
		const url = `${environment.smartServiceURL}/api/smart/v1/refund/residential`;
		return this.apiService.post(url, payload);
	}

	addDisability(payload) {
		const url = `${environment.smartServiceURL}/api/smart/v1/tc/createDisabilityWorkflow`;
		return this.apiService.post(url, payload);
	}

	getDisabilityTypeRequests(query) {
		const url = `${environment.smartServiceURL}/api/smart/v1/tc/getDisabilityWorkflow?${query}`;
		return this.apiService.get(url);
	}


	submitSSCReviewforDisability(payload) {
		const url = `${environment.smartServiceURL}/api/smart/v1/tc/reviewDisabilityTypeBySSC`;
		return this.apiService.post(url, payload);
	}

}
